import { useState, useRef, useEffect, createElement } from 'react';
import classNames from 'classnames';
import './index.scss';
const ColorfulNotice = props => {
    const classPrefix = `au-notice`;
    const speed = 50;
    const { content, type, closeable, onClose, ...otherProps } = props;
    const containerRef = useRef(null);
    const textRef = useRef(null);
    const [visible, setVisible] = useState(true);
    const animatingRef = useRef(false);
    function start() {
        const container = containerRef.current;
        const text = textRef.current;
        if (!container || !text)
            return;
        if (container.offsetWidth >= text.offsetWidth) {
            animatingRef.current = false;
            text.style.removeProperty('transition-duration');
            text.style.removeProperty('transform');
            return;
        }
        if (animatingRef.current)
            return;
        const initial = !text.style.transform;
        text.style.transitionDuration = '0s';
        if (initial) {
            text.style.transform = 'translateX(0)';
        }
        else {
            text.style.transform = `translateX(${container.offsetWidth}px)`;
        }
        const distance = initial
            ? text.offsetWidth
            : container.offsetWidth + text.offsetWidth;
        animatingRef.current = true;
        text.style.transitionDuration = `${Math.round(distance / speed)}s`;
        text.style.transform = `translateX(-${text.offsetWidth}px)`;
    }
    useEffect(() => {
        setTimeout(() => {
            start();
        }, 1000);
    }, [content]);
    if (!visible)
        return null;
    return (createElement("div", { className: classNames(classPrefix, `${classPrefix}-${props.type}`), ...otherProps },
        createElement("label", { className: 'au-icon-model' },
            createElement("i", { className: "icon-bell" })),
        createElement("span", { ref: containerRef, className: `${classPrefix}-content` },
            createElement("span", { onTransitionEnd: () => {
                    animatingRef.current = false;
                    start();
                }, ref: textRef, className: `${classPrefix}-content-inner` }, content)),
        closeable && (createElement("label", { className: `${classPrefix}-close`, onClick: () => {
                setVisible(false);
                onClose?.();
            } },
            createElement("i", { className: "icon-times-circle" })))));
};
ColorfulNotice.displayName = 'ColorfulNotice';
export default ColorfulNotice;
